<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="onSubmit">
      <!-- address -->
      <div class="columns is-variable is-1 mb-0">
        <div class="column is-4">
          <ValidationProvider name="name" rules="required" v-slot="{ errors }">
            <b-field
              :message="errors[0]"
              :type="errors[0] ? 'is-danger' : ''"
              label="Clínica"
              label-position="on-border"
            >
              <b-input v-model="address.name"></b-input>
            </b-field>
          </ValidationProvider>
        </div>
        <div class="column is-4">
          <b-field label="Consultório Nº" label-position="on-border">
            <b-input v-model="address.officeNo"></b-input>
          </b-field>
        </div>
      </div>
      <div class="columns is-variable is-1 mb-0">
        <div class="column is-4">
          <ValidationProvider name="zip" rules="required" v-slot="{ errors }">
            <b-field
              :message="errors[0]"
              :type="errors[0] ? 'is-danger' : ''"
              label="Cep"
              label-position="on-border"
            >
              <b-input
                v-on:keyup.native="getAddress"
                v-model="address.zip"
                v-mask="'##.###-###'"
              ></b-input>
            </b-field>
          </ValidationProvider>
        </div>

        <div class="column is-8">
          <ValidationProvider
            name="street"
            rules="required"
            v-slot="{ errors }"
          >
            <b-field
              :message="errors[0]"
              :type="errors[0] ? 'is-danger' : ''"
              label="Rua/Av."
              label-position="on-border"
            >
              <b-input v-model="address.street"></b-input>
            </b-field>
          </ValidationProvider>
        </div>
      </div>

      <div class="columns is-variable is-1 mb-0">
        <div class="column is-4">
          <ValidationProvider
            name="number"
            rules="required"
            v-slot="{ errors }"
          >
            <b-field
              :message="errors[0]"
              :type="errors[0] ? 'is-danger' : ''"
              label="Número"
              label-position="on-border"
            >
              <b-input v-model="address.number"></b-input>
            </b-field>
          </ValidationProvider>
        </div>

        <div class="column is-3">
          <ValidationProvider name="complement">
            <b-field label="Comp." label-position="on-border">
              <b-input v-model="address.complement"></b-input>
            </b-field>
          </ValidationProvider>
        </div>

        <div class="column is-5">
          <ValidationProvider
            name="neighborhood"
            rules="required"
            v-slot="{ errors }"
          >
            <b-field
              :message="errors[0]"
              :type="errors[0] ? 'is-danger' : ''"
              label="Bairro"
              label-position="on-border"
            >
              <b-input v-model="address.neighborhood"></b-input>
            </b-field>
          </ValidationProvider>
        </div>
      </div>

      <div class="columns is-variable is-1 mb-0">
        <div class="column">
          <ValidationProvider name="city" rules="required" v-slot="{ errors }">
            <b-field
              :message="errors[0]"
              :type="errors[0] ? 'is-danger' : ''"
              label="Cidade"
              label-position="on-border"
            >
              <b-input v-model="address.city"></b-input>
            </b-field>
          </ValidationProvider>
        </div>

        <div class="column">
          <ValidationProvider name="state" rules="required" v-slot="{ errors }">
            <b-field
              :message="errors[0]"
              :type="errors[0] ? 'is-danger' : ''"
              label="Uf"
              label-position="on-border"
            >
              <b-input v-model="address.state"></b-input>
            </b-field>
          </ValidationProvider>
        </div>
        <div class="column">
          <ValidationProvider name="tz" rules="required" v-slot="{ errors }">
            <b-field
              :message="errors[0]"
              :type="errors[0] ? 'is-danger' : ''"
              label="Fuso horário"
              label-position="on-border"
            >
              <b-select v-model="address.tz" expanded>
                <option v-for="(tz, index) in tzNames" :value="tz" :key="index">
                  {{ tz }}
                </option>
              </b-select>
            </b-field>
          </ValidationProvider>
        </div>
      </div>
      <!-- end address -->
      <!-- Button -->
      <div class="buttons">
        <b-button label="Enviar" type="is-info" native-type="submit" />
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import moment from "moment-timezone";
import { mask } from "vue-the-mask";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Esse campo é requerido",
});
let address = {};
export default {
  name: "OfficeAddress",
  props: ["officeId", "address"],
  directives: { mask },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      foundAddress: false,
    };
  },
  computed: {
    tzNames: () => moment.tz.names(),
  },
  methods: {
    getAddress: function () {
      this.foundAddress = false;
      if (/^[0-9]{2}\.[0-9]{3}-[0-9]{3}$/.test(this.address.zip)) {
        let zip = this.address.zip.replace(/\D/g, "");
        this.$http
          .get(`https://viacep.com.br/ws/${zip}/json`)
          .then((response) => {
            if (response.erro) {
              this.address = {};
              this.foundAddress = false;
              return;
            }
            address = {
              name: this.address.name,
              zip: response.data.cep,
              street: response.data.logradouro,
              neighborhood: response.data.bairro,
              city: response.data.localidade,
              state: response.data.uf,
            };
            if (address.city) {
              let regex = RegExp("(" + address.city + ")", "gi");
              address.tz =
                this.tzNames.find((value) => regex.test(value)) || "undefined";
            }
            this.$emit("setAddress", address);
            this.foundAddress = true;
          });
      }
    },
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }

        this.$http.put(`office/${this.officeId}`, {
          address: this.address,
        });
        // .then((response) => {
        //   address._id = response.data._id;
        //   this.$emit("setAddress", address);
        // });

        //this.$refs.form.reset();
      });
    },
  },
  mounted() {},
};
</script>